import { Service } from '@mi-front/core';
import { Chip } from '@mi-front/ui';

import { FormattedMessage } from 'react-intl';
export function ServiceStatus(p: { service: Service }) {
  const { status } = p.service;

  const chipType = status === 'Running' ? 'success' : status === 'Stopped' ? 'danger' : 'warning';

  return (
    <Chip type={chipType}>
      <FormattedMessage
        id={`streamerBox.serviceStatus.${status.toLowerCase()}`}
        defaultMessage={status}
      />
    </Chip>
  );
}
